import { NavLink, Outlet } from 'react-router-dom';
import { useAgent } from '@/auth/use-agent';
import { Button } from '@/ui/Button';
import { ACCESS_LOGOUT_PATH, PROXY_AUTH } from '@/api/config';

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/links', label: 'Link builder', end: false },
  { to: '/whales', label: 'Whales', end: false },
  { to: '/ar-traffic', label: 'Argentina traffic', end: false },
  { to: '/deposit-timing', label: 'Deposit timing', end: false },
  { to: '/wheel', label: 'Daily wheel spins', end: false },
  { to: '/aff-trend', label: 'Affiliate trend', end: false },
  { to: '/aff-comparison', label: 'Affiliate comparison', end: false },
];

// Middleware refuses these to agent keys (403); the links are hidden for them too.
const ADMIN_NAV = [{ to: '/traffic-quality', label: 'Traffic quality', end: false }];

export function AppLayout() {
  const { agent, signOut } = useAgent();

  return (
    <div className="min-h-screen md:flex">
      <aside className="border-b border-slate-200 bg-white md:w-56 md:shrink-0 md:border-b-0 md:border-r">
        <div className="px-5 py-4">
          <p className="text-sm font-semibold">HiSpin support</p>
          <p className="text-xs text-slate-500">Limited tournaments</p>
        </div>
        <nav className="flex gap-1 px-3 pb-3 md:flex-col md:pb-0">
          {[...NAV, ...(agent.admin ? ADMIN_NAV : [])].map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium ${isActive ? 'bg-blue-50 text-blue-700' : 'text-slate-700 hover:bg-slate-100'}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <header className="flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-6 py-3">
          <p className="text-sm text-slate-600">
            Signed in as <span className="font-semibold text-slate-900">{agent.agentId}</span>
            {agent.admin && (
              <span className="ml-2 rounded bg-slate-200 px-1.5 py-0.5 text-xs font-semibold">admin</span>
            )}
          </p>
          <Button variant="secondary" onClick={PROXY_AUTH ? () => window.location.assign(ACCESS_LOGOUT_PATH) : signOut}>
            Sign out
          </Button>
        </header>
        <main className="px-6 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
